import { FiltersToApplyOnInbox } from "containers/admin/inbox/inbox.types";
import { InboxFilter, QuickFilterTypes } from "types/inbox";

import { INBOX_FILTER_IDS } from "containers/admin/inbox/inbox.consts";

export const getFilters = (filtersToApply: FiltersToApplyOnInbox): InboxFilter => {
  const quickFilters = filtersToApply[INBOX_FILTER_IDS.quickFilters] ?? [];
  const comments = filtersToApply[INBOX_FILTER_IDS.comments] ?? [];

  const filters: InboxFilter = {
    touchpointVersionStatus: filtersToApply[INBOX_FILTER_IDS.clientReviewStatus] ?? [],
    touchpointType: filtersToApply[INBOX_FILTER_IDS.creativeType] ?? [],
    touchpointContentType: filtersToApply[INBOX_FILTER_IDS.contentTypes] ?? [],
    programTypes: filtersToApply[INBOX_FILTER_IDS.programType] ?? [],
    populationType: filtersToApply[INBOX_FILTER_IDS.populationType] ?? [],
    classes: filtersToApply[INBOX_FILTER_IDS.classes] ?? [],
    hasOpenComments: comments.includes("has-open-comments"),
    hasOpenActionComments: comments.includes("has-action-items"),
  };

  // Quick filter: "Has open action items" forces both flags to true.
  if (quickFilters.includes(QuickFilterTypes.hasOpenActionItems)) {
    filters.hasOpenActionComments = true;
    filters.hasOpenComments = true;
  }

  return filters;
};
